export enum ModifiersIdsEnum {
    floater = 16,
    pallets = 14,
    bottomDeckBoard = 17,
    gussets = 19,
    fullPerpendicularRubStrips = 18
}

export enum DocumentTypeIdsEnum {
    estimate = 1,
    quote = 2,
    houseBill = 3,
    bol = 4,
    shippingLabel = 5,
    cutSheet = 6,
    invoice = 7,
    custom = 8,
    requestForPrice = 9,
    notificationOfArrival = 10,
    statusChangeCarrierPickup = 11
}

export enum ItemCategoryEnum {
    electronics = 'Electronics',
    furniture = 'Furniture',
    lighting = 'Lighting',
    industrial = 'Industrial',
    stone = 'Stone',
    glass = 'Glass',
    art = 'Art',
    prepacked = 'Prepacked',
    productionCrate = 'Production Crate',
    custom = 'Custom',
    hazmat = 'Hazmat'
}

export enum OrderTypeEnum {
    quickQuote = 1,
    quote = 2,
    job = 3,
}

export enum CalenderViewTypeEnum {
    Day = 1,
    Week = 2,
    Month = 3
}

export enum MaterialCategoryEnum {
    lumber = 1,
    plywood = 2,
    prep = 3,
    nutsBoltsAndHardware = 4,
    corrugated = 5,
    cushioning = 3,
    fill = 6
}

export enum MaterialComponentNameEnum {
    deckBoard = 'Deck Board',
    rippedDeckBoard = 'Ripped Deck Board',
}

export enum InsuranceCoverageTypeNameEnum {
    services = 'Services',
    items = 'Items',
    materials = 'Materials',
    labor = 'Labor',
    shipping = 'Shipping'
}

export enum ShippingContactTypeNameEnum {
    shipper = 1,
    consignee = 2,
    payer = 3,
    intermediary = 4,
}

export enum ExcessValueTypeEnum {
    excessValueOne = 1,
    excessValueTwo = 2,
    excessValueThree = 3,
    excessValueFour = 4,
    excessValueFive = 5
}

export enum LabourMethodTypeEnum {
    lowestLaborMethod = 1,
    highestLaborMethod = 2,
    volumeLaborMethod = 3,
    cutLinearLaborMethod = 4,
    averageVal = 5,
    fixedLabor = 6,
    customMinutes = 7
}

export enum AccountTypeEnum {
    lead = 1,
    customer = 2,
}

export enum IndustryLookupEnum {
    Arts_Antiques = 1,
    Commercial = 2,
    Display = 3,
    Telecommunications = 4,
    industryName = 5,
    Industrial = 6,
    Manufacturing = 7,
    Auctions = 8,
    Residential = 9,
    Retail = 10,
    Medical = 11,
    Transportation = 12,
    Aerospace = 13,
    Furniture = 14
}

export enum JobTypeLookupEnum {
    PackAndShip = 1,
    PackOnly = 2,
    Delivery = 3,
    LocalDel = 4,
    CustomCrateOrder = 5,
    ShipOnly = 6,
    Storage = 7,
}

export enum CountryLookupEnum {
    USA = 1
}

export enum ContainerLookupCallFromTypeEnum {
    order = 'Order',
    quickQuote = 'QuickQuote',
    quickCutSheet = 'QuickCutSheet'
}

export enum NumberValueEnum {
    fixAccountId = 99999999999
}

export enum InsuranceProviderIdEnum {
    crsProviderId = 1
}

export enum LaborTierTypeIdEnum {
    cutLaborTierTypeId = 3
}

export enum UnitsEnum {
    Inches = 1,
    Feet = 2,
    SquareInches = 3,
    SquareFeet = 4,
    CubicInches = 5,
    CubicFeet = 6,
    Each = 7

}
